import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { CLIENT_API_URL, CS_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class ClientService {
  /**
   * @async
   * @function createClient
   * postCreateClient
   * @param {Object} client object with client data
   * @param {string} client.firstName  * Test
   * @param {string} client.phoneNumber * +7 (999) 999-99-99
   * @param {string} client.email test@test.com
   * @param {string} client.additionalPhoneNumber +7 (999) 999-99-99
   * @return  {Object}  with id client
   * @example postCreateClient({firstName,phoneNumber,email})
   *
   */
  static createClient = async (client = {}) => {
    try {
      const res = await HTTPHandler.post(CLIENT_API_URL + '/clients', client)
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /**
   * @async
   * @function getClientByPhone
   * getClientByPhone
   * @param {string} phoneNumber +7 (999) 999-99-99
   * @return Array clients or error { err: 'Ошибка', status: "optional" }
   * @example getClientByPhone(phoneNumber)
   *
   */
  static getClientByPhone = async phoneNumber => {
    try {
      const res = await HTTPHandler.get(
        CLIENT_API_URL + '/clients/getByPhoneNumber/' + phoneNumber
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /**
   * @async
   * @function getClientByID
   * getClientByID
   * @param {string} id 1
   * @return  {Object}  client
   * @example getClientByID(id)
   *
   */
  static getClientByID = async id => {
    try {
      const res = await HTTPHandler.get(
        CLIENT_API_URL + '/clients/getById/' + id
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
}
